module.exports = __webpack_public_path__ + "cw.04e8f79843fd4baa0921.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cw.svg
// module chunks = styles